import { memo, useEffect } from 'react'
import { useAppDispatch } from '../../../../../../../hooks/useAppDispatch'
import { useAppSelector } from '../../../../../../../hooks/useAppSelector'
import { selectRuleConfigBit } from '../../../../../../../store/selectors/ruleCardSelectors'
import { PATH_JOINER } from '../../../../../utils/getConfigBitPath'
import { useFormValidation } from '../../../../../../../hooks/useFormValidation'
import { getLabel } from '../../../../../../../utils/getLabel'
import {
    initRuleEmptyData,
    modifyRuleCardConfig,
} from '../../../../../../../store/actions/ruleCardActions'
import {
    buildControlsExt,
    selectInput,
} from '../../../../../../inputs/controls'

export interface Props {
    dataPath: string
    dataSchema: any
    name: string
    wrapper?: string
}

export const RuleEnum = memo(function RuleEnum({
    dataPath,
    dataSchema = {},
    name,
    wrapper,
}: Props) {
    const dispatch = useAppDispatch()
    const pathSplit = dataPath.split(PATH_JOINER)
    const configBit = useAppSelector(selectRuleConfigBit(pathSplit))
    const path = [...pathSplit, name]
    const [inputState, setInputState, touched, setTouched] = useFormValidation(
        configBit,
        {}
    )
    const label= getLabel(name, dataSchema.name)
    const className = !wrapper ? 'w-50 pe-2' : ''
    const selected = Object.entries(dataSchema.options).find((option) =>
        option.find((el) => el === configBit?.[name])
    )?.[0]

    useEffect(() => {
        if (configBit && dataPath.length) {
            setInputState({ configBit, [name]: selected })
        }
    }, [configBit]) // eslint-disable-line

    useEffect(() => {
        if (dataPath.length) {
            if (
                !configBit ||
                !Object.keys(configBit).length ||
                typeof configBit?.[name] === 'undefined'
            ) {
                dispatch(initRuleEmptyData({ schema: dataSchema, name, path }))
            }
        }
    }, []) // eslint-disable-line

    useEffect(() => {
        if (Object.keys(touched).length && dataPath.length) {
            // dispatch(enumActions.modify(inputState[name], path, inputState[name]))
            dispatch(modifyRuleCardConfig({ path, data: inputState }))
        }
    }, [inputState]) // eslint-disable-line

    const controlDescriptors = [
        selectInput({
            name,
            options: Object.keys(dataSchema.options),
            selected: configBit?.[name] || dataSchema?.default || 0,
            tooltipText: dataSchema.description,
            changeWarning: dataSchema.change_warning,
            label,
            className,
            isColumn: true,
        }),
    ]

    const EnumInput = buildControlsExt(
        controlDescriptors,
        inputState,
        setInputState,
        touched,
        setTouched
    )

    return <div className={`${!wrapper ? 'w-100' : ''}`}>{EnumInput}</div>
})
